export default __webpack_public_path__ + "static/media/mh-5.3564a572.png";